var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "announcement" },
      [
        _c("page-title-secondary", { attrs: { title: "关于我们" } }),
        _vm._v(" "),
        _c("div", { staticClass: "announcement__detail" }, [
          _c(
            "div",
            {
              staticClass:
                "announcement__detail-title announcement__detail-title--top"
            },
            [_vm._v("关于我们")]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "announcement__detail-txt",
            domProps: { innerHTML: _vm._s(_vm.content) }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.partnerFlag,
                  expression: "partnerFlag"
                }
              ],
              staticClass: "announcement__detail-title"
            },
            [_vm._v("合作伙伴")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "announcement__detail-imgs" },
            _vm._l(_vm.partnerVoList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "announcement__detail-img-item" },
                [
                  _c("img", {
                    staticClass: "announcement__detail-img",
                    attrs: { src: item.logoUrl },
                    on: {
                      click: function($event) {
                        return _vm.openWin(item)
                      }
                    }
                  })
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.friendshipFlag,
                  expression: "friendshipFlag"
                }
              ],
              staticClass: "announcement__detail-title"
            },
            [_vm._v("友情链接")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "announcement__detail-imgs" },
            _vm._l(_vm.friendshipLinksVoList, function(item, index) {
              return _c(
                "div",
                { key: index, staticClass: "announcement__detail-img-item" },
                [
                  _c("img", {
                    staticClass: "announcement__detail-img",
                    attrs: { src: item.logoUrl },
                    on: {
                      click: function($event) {
                        return _vm.openWin(item)
                      }
                    }
                  })
                ]
              )
            }),
            0
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fe5355d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fe5355d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/aboutUs/aboutUs.vue
// module id = null
// module chunks = 